import { render } from "./QwButtonEdit.vue?vue&type=template&id=07e8aca4"
import script from "./QwButtonEdit.vue?vue&type=script&lang=js"
export * from "./QwButtonEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__